<template>
  <state
    :state="'success'"
    :message="message"
    :link="link"
    :linkText="linkText"
  />
</template>

<script>
import State from '@/components/layout/State.vue';

export default {
  components: { State },
  props: {
    message: {
      default: '',
    },
    link: {
      default: '/',
    },
    linkText: {
      default: 'GO_TO_MAIN_PAGE',
    },
  },
  computed: {
    title() {
      return this.$t('OK');
    },
  },
};
</script>
